import React, { useEffect } from 'react';
import styles from './ClosableModal.module.css';
import { IoClose } from 'react-icons/io5';
import classNames from 'classnames';
import BaseModal from 'components/Modals/BaseModal';

export default function ClosableModal({
  className,
  style,
  open,
  onClose,
  children,
  title,
  closeButton,
}) {
  if (open)
    return (
      <div
        className="position-absolute w-100 h-100 top-0 start-0 d-flex justify-content-center align-items-center"
        style={{ zIndex: 1000, backgroundColor: '#0000004f' }}
        onMouseDown={onClose}
      >
        <div
          className={
            'd-flex flex-column w-75 h-75 border border-white rounded overflow-auto bg-base ' +
            className
          }
          style={style}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          {(title || closeButton) && (
            <div className="d-flex flex-row justify-content-between">
              {title ? <h4>{title}</h4> : <div />}
              {closeButton && (
                <div className="btn" onClick={onClose}>
                  <IoClose size={20} />
                </div>
              )}
            </div>
          )}

          <div className="flex-fill d-flex">{children}</div>
        </div>
      </div>
    );
}
